import React from "react";
import { Box, Grid, Typography, IconButton } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import TwitterIcon from '@mui/icons-material/Twitter';

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f7f7f7", // Light gray background
          padding: 4,
          textAlign: "center",
        }}
      >
        {/* Social Media Section */}
        <Typography variant="h6" id="socials-title" sx={{ color: "#1976d2", mb: 2 }}>
          Follow Us
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4 }}>
          <IconButton href="#" aria-label="TwitterIcon" sx={{ color: "#1976d2" }}>
            <TwitterIcon sx={{ fontSize: 40 }}  />
          </IconButton>
          <IconButton href="#" aria-label="Facebook" sx={{ color: "#1976d2" }}>
            <FacebookIcon sx={{ fontSize: 40 }}  />
          </IconButton>
          <IconButton href="#" aria-label="Instagram" sx={{ color: "#1976d2" }}>
            <InstagramIcon sx={{ fontSize: 40 }}  />
          </IconButton>
          <IconButton href="#" aria-label="Pinterest" sx={{ color: "#1976d2" }}>
            <PinterestIcon sx={{ fontSize: 40 }}  />
          </IconButton>
        </Box>

        {/* Footer Links */}
        {/* <Grid container spacing={4} justifyContent="center">
          <Grid item xs={6} md={6} lg={4}>
            <Typography variant="h6" className="resources-title" sx={{ fontWeight: "bold", mb: 2 }}>
              Popular Resources
            </Typography>
            <Typography variant="body2">About Us</Typography>
            <Typography variant="body2">Careers</Typography>
            <Typography variant="body2">Press</Typography>
            <Typography variant="body2">FAQs</Typography>
            <Typography variant="body2">Customer Care</Typography>
            <Typography variant="body2">Redeem</Typography>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <Typography variant="h6" className="resources-title" sx={{ fontWeight: "bold", mb: 2 }}>
              More ABCmouse®
            </Typography>
            <Typography variant="body2">Schools</Typography>
            <Typography variant="body2">Libraries</Typography>
            <Typography variant="body2">Teachers</Typography>
            <Typography variant="body2">En español</Typography>
            <Typography variant="body2">Learning</Typography>
            <Typography variant="body2">Games</Typography>
          </Grid>
        </Grid> */}
      </Box>
      <Box className="footer-buttom" >
        <Grid sx={{
           
          padding: 10,
          textAlign: "center",
          color:"#FFF"
        }}>
        {/* <Typography variant="h6" className="resources-title" sx={{ fontWeight: "bold", mb: 2 }}>
          More Actify365
        </Typography> */}
        <Typography variant="body2"> All rights reserved@2024-2025 </Typography>
        <Typography variant="body2"> Contact Us: </Typography>
        <Typography variant="body2">  Email: info@actify365.com </Typography>
          </Grid>
      </Box>
    </>
  );
};

export default Footer;
